import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { withLatestFrom, filter, mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import AppState from '../../state';
import {
  AutoSaveMerchError,
  AutoSaveMerchSuccess,
  ChangeMerchColor,
  ChangeMerchDesignPosition,
  CreateMerch,
  UpdateMerch,
  UpdateMerchImages,
  UploadMerchImageSuccess,
} from '../action-creators';
import {
  CHANGE_MERCH_COLOR,
  CHANGE_MERCH_DESIGN_POSITION,
  UPLOAD_MERCH_IMAGE_SUCCESS,
  UPDATE_MERCH_IMAGES,
} from '../actions';
import { createMerchRequest } from '../selectors';
import { CreateProductRequest } from '@services/merch/types/api/create-product';
import { UpdateProductRequest } from '@services/merch/types/api/update-product';

export const autoSaveMerchEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<
      Actions,
      | UploadMerchImageSuccess
      | ChangeMerchDesignPosition
      | ChangeMerchColor
      | UpdateMerchImages
    >(
      UPLOAD_MERCH_IMAGE_SUCCESS,
      CHANGE_MERCH_DESIGN_POSITION,
      CHANGE_MERCH_COLOR,
      UPDATE_MERCH_IMAGES
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    mergeMap(async ([_, state]) => {
      try {
        const artistId = state.artist.active?.id || '';
        const productId =
          state.merch.active?.editProduct?.id ||
          state.merch.active?.newProduct?.productId;

        const request = createMerchRequest(state.merch);

        if (request.imageId) {
          if (!productId) {
            return new CreateMerch(request as CreateProductRequest, artistId);
          } else {
            return new UpdateMerch(request as UpdateProductRequest, productId, artistId, false);
          }
        }

        return new AutoSaveMerchSuccess();
      } catch (err) {
        return new AutoSaveMerchError((err as Error).message);
      }
    })
  );
